/* eslint-disable no-prototype-builtins */
import React, { useEffect, useState } from 'react';
import { CheckedList } from 'modules/Modals/old/FilterModal/components/CheckboxGroup';
import { CollapsedTab } from 'modules/Modals/old/FilterModal/components/CollapsedTab';
import { NewFiltersEntity, OldFilterEntity } from '_entities';
import { IsVaAccount, HasAccess, IsMdAccount } from 'modules';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'ui-kit';
import Location from 'modules/Modals/FilterPages/Location';
import { PERMISSIONS } from '_constants';
import { FILTER_FIELDS, FILTER_RETAILERS } from '_constants/old/filters';
import { FormGroup } from 'modules/Modals/old/FilterModal/components/FormGroup';
import RadioButtonsOrganizer from 'ui-kit/old/radioButton/radioButtonsOrganizer';
import { getEnforcementRetailerCharacteristics } from './enforcementRetailerCharacteristicsTabs';
import * as Styled from './styles';

const { setShadowFilter } = OldFilterEntity.actions;
const { getCorporation } = NewFiltersEntity.actions;
const { getRetailerCorporationOptions } = NewFiltersEntity.selectors;

function VisitsRetailerCharacteristics() {
  const [isLoading, setIsLoading] = useState(true);
  const corporationOptions = useSelector(getRetailerCorporationOptions);
  const {
    filter: { shadowFilters },
  } = useSelector((state) => state);
  const isVaAccount = IsVaAccount();
  const isMdAccount = IsMdAccount();
  const hasResidentialModule = HasAccess(PERMISSIONS.RESIDENTIAL_LOCATION);
  const [atccYear, setAtccYear] = useState(new Date().getFullYear().toString());
  const dispatch = useDispatch();
  useEffect(() => {
    (async function getDataForCorporation() {
      try {
        await dispatch(getCorporation());
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);
  const tabs = getEnforcementRetailerCharacteristics(
    corporationOptions,
    isVaAccount,
    hasResidentialModule,
    isMdAccount,
  );

  const getElement = (item) => {
    switch (item.type) {
      case 'single':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            <CheckedList name={item.field} options={item.options} />
          </CollapsedTab>
        );
      case 'multiple':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            {item.collapsed.map((elem) => (
              <Styled.FiltersContainer>
                <Styled.FiltersTitle isSubcategory={elem?.isSubcategory}>{elem.title}</Styled.FiltersTitle>
                <CheckedList name={elem.field} options={elem.options} isSubcategory={elem?.isSubcategory} />
              </Styled.FiltersContainer>
            ))}
          </CollapsedTab>
        );
      case 'double':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            {item.collapsed.map((elem) => (
              <CheckedList name={elem.field} options={elem.options} />
            ))}
          </CollapsedTab>
        );
      default:
        return null;
    }
  };

  const filters = {
    [FILTER_FIELDS.ATCC]: null,
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    const numericValue = inputValue.replace(/\D/g, '').slice(0, 4);

    setAtccYear(numericValue);

    if (numericValue.length === 4) {
      handleChangeFiltersAtccYear(FILTER_FIELDS.ATCC, { value: numericValue });
    }
  };

  const RADIO_BUTTONS = [
    {
      value: FILTER_RETAILERS.ATCC_OPTIONS.OPTION_IS_ATCC,
      checked: shadowFilters[FILTER_FIELDS.ATCC] === 't',
    },
    {
      value: FILTER_RETAILERS.ATCC_OPTIONS.OPTION_ATCC_CERTAIN_YEAR,
      checked: shadowFilters[FILTER_FIELDS.ATCC] === atccYear,
      customComponent: (
        <Styled.TextInputContainer>
          <Styled.TextInputLabel htmlFor="year-input" />
          <Styled.TextInput
            id="year-input"
            type="text"
            value={atccYear}
            onChange={handleInputChange}
            placeholder={atccYear}
            maxLength={4}
          />
        </Styled.TextInputContainer>
      ),
    },
    {
      value: FILTER_RETAILERS.ATCC_OPTIONS.OPTION_NOT_ATCC,
      checked: shadowFilters[FILTER_FIELDS.ATCC] === 'f',
    },
  ];

  const handleChangeFiltersAtccYear = (field, { value }) => {
    const newFilters = { ...shadowFilters };
    switch (field) {
      case FILTER_FIELDS.ATCC:
        dispatch(
          setShadowFilter({
            ...newFilters,
            ...{ [FILTER_FIELDS.ATCC]: value },
          }),
        );
        break;
      default:
        break;
    }
  };

  const handleRadioButton = (value) => {
    switch (value) {
      case FILTER_RETAILERS.ATCC_OPTIONS.OPTION_IS_ATCC:
        filters[FILTER_FIELDS.ATCC] = 't';
        break;
      case FILTER_RETAILERS.ATCC_OPTIONS.OPTION_ATCC_CERTAIN_YEAR:
        filters[FILTER_FIELDS.ATCC] = atccYear;
        break;
      case FILTER_RETAILERS.ATCC_OPTIONS.OPTION_NOT_ATCC:
        filters[FILTER_FIELDS.ATCC] = 'f';
        break;
      default:
        break;
    }
    dispatch(setShadowFilter({ ...shadowFilters, ...filters }));
  };

  return (
    <Styled.FilterContainer>
      {isLoading && <Loader />}
      <Styled.Wrapper>
        {tabs.map((item) => getElement(item))}
        <CollapsedTab title="Location" key="152">
          <Location />
        </CollapsedTab>
        {isMdAccount && (
          <FormGroup title="ATCC">
            <RadioButtonsOrganizer
              hideResetButton
              radioButtons={RADIO_BUTTONS}
              onChange={({ value }) => handleRadioButton(value)}
              name="atcc"
              isColumn
            />
          </FormGroup>
        )}
      </Styled.Wrapper>
    </Styled.FilterContainer>
  );
}

export default VisitsRetailerCharacteristics;
